import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useRef } from 'react';
import WrapperButton from '../../../../components/buttons/WrapperButton';
import { useQuery } from '@tanstack/react-query';
import { ApiError } from '../../../../Interfaces/system/Generic.interfaces';
import ErrorToast, {
  showToast,
} from '../../../../components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';
import { downloadFile } from '@/src/utils/fileUtil';
import { fetchClaimAttachment } from '@/src/app/services/Insurance/Claim';

type ClaimAttachmentProps = {
  claimID: string;
  attachmentName?: string;
  showIcon?: boolean;
};

const ClaimAttachment = ({
  claimID,
  attachmentName,
  showIcon,
}: ClaimAttachmentProps) => {
  const toast = useRef<Toast>(null);

  const { isFetching, refetch } = useQuery({
    queryKey: ['getClaimAttachments', claimID],
    queryFn: ({ signal }) => fetchClaimAttachment(claimID, signal),
    refetchOnWindowFocus: false,
    enabled: false,
    onSuccess: (data) => {
      downloadFile(data, attachmentName);
    },
    onError: (error: ApiError) => {
      const errorMessage = error.response?.data?.message;
      showToast(
        'error',
        toast,
        'Download Error',
        errorMessage ??
          `Couldn't download the attachment! Please try again later.`,
        3000
      );
    },
  });

  if (showIcon) {
    return (
      <div>
        <ErrorToast toastRef={toast} />
        {isFetching && <ProgressSpinner className="w-1rem h-auto" />}
        {!isFetching && (
          <WrapperButton onClick={() => refetch()}>
            <i className="pi pi-paperclip totalColor" />
          </WrapperButton>
        )}
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorToast toastRef={toast} />
      <label className="text-18px block mb-2 font-bold">Attachment:</label>
      <div>
        {isFetching && <ProgressSpinner className="w-1rem h-auto" />}
        {!isFetching && (
          <WrapperButton
            className={attachmentName ? 'totalColor' : 'blackText'}
            onClick={attachmentName ? () => refetch() : undefined}
            disabled={!attachmentName}
          >
            {attachmentName ?? '-'}
          </WrapperButton>
        )}
      </div>
    </React.Fragment>
  );
};

export default ClaimAttachment;
